/**
 * Holds the last known pointer position in the viewport.
 *
 * The position used to live only in the custom properties `--mouse-x` / `--mouse-y` on <html>,
 * written on every mouse move. A custom property on the root element invalidates the style of the
 * whole document, so every mouse move restyled every element on the page (measured 2026-09-30:
 * about 0.6 ms per tasklist card under a 4x CPU throttle). The position is now tracked here, and
 * written onto <html> only when a consumer needs it there (see `UiHelper.popover`).
 */
export class PointerPositionHelper {

    private static _x: number | null = null;

    private static _y: number | null = null;

    /**
     * Stores the pointer position (viewport coordinates, as in `MouseEvent.clientX/Y`).
     */
    public static update(x: number, y: number): void {
        PointerPositionHelper._x = x;
        PointerPositionHelper._y = y;
    }

    /**
     * The last stored horizontal position, or null before the first mouse move.
     */
    public static get x(): number | null {
        return PointerPositionHelper._x;
    }

    /**
     * The last stored vertical position, or null before the first mouse move.
     */
    public static get y(): number | null {
        return PointerPositionHelper._y;
    }
}
